import React, { createContext, useContext } from 'react';
import { useWishlist } from '../hooks/useWishlist';

const WishlistContext = createContext(null);

export function WishlistProvider({ currentUser, isLoggedIn, children }) {
  const wishlist = useWishlist(currentUser, isLoggedIn);
  return (
    <WishlistContext.Provider value={wishlist}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlistContext() {
  const ctx = useContext(WishlistContext);
  if (!ctx) {
    throw new Error('useWishlistContext must be used inside <WishlistProvider>');
  }
  return ctx;
}
